/**
 * 개인정보처리방침
 */
import React, { Component } from 'react';

import { Container, Navbar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';

class TermsCmp extends Component {
  componentDidMount = () => {
    // 뒤로 이동 버튼 바인딩
    $('.goBackBtn').on('click', () => {
      if (this.props.history !== null && typeof (this.props.history) !== undefined) this.props.history.go(-1);
    });
  }

  render() {

    return (
      <>
        {/* header */}
        <Navbar fixed="top" className="title">
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          스쿨라이프 개인정보처리방침
        </Navbar>
        <Container style={{ paddingTop: '5rem', paddingBottom: '5rem' }}>
          <div id="subRight_1">
            <div id="subRight_7_1">'스쿨라이프' 개인정보 처리방침이란 '스쿨라이프' 서비스를 이용하는 사용자(회원)들의 권익을 보호하여 회원님이 안심하고 서비스를 제공받을 수 있도록 '스쿨라이프'가 준수하여야 할 개인정보보호 지침을 말합니다. '스쿨라이프'는 서비스의 원활한 제공에 필요한 최소한의 정보를 수집하고 있으며, 회원님으로부터 수집되는 개인정보를 매우 중요하게 생각하고 있습니다. <br />
              <br />
              '스쿨라이프'는 법률의 규정에 의해 허용되거나 회원님의 동의가 있는 경우를 제외하고는 회원님의 개인정보를 제3자에게 제공하지 않음은 물론 개인정보가 외부로 유출되지 않도록 항상 최선을 다하고 있으며, 다음과 같은 개인정보 처리방침 (Privacy Policy)을 시행하고 있습니다. <br />
            </div>
            <ul id="subRight_7">
              <li>'스쿨라이프' 개인정보 처리방침의 목적
                <ul>
                  <li>'스쿨라이프'의 개인정보 처리방침은 정보통신망이용촉진등에 관한 법률<br />
                    (이하 '법률'이라 합니다) 제16조(개인정보의 수집 및 처리) 내지 18조(이용자의 권리) 및 '스쿨라이프' 이용약관(제9조 스쿨라이프의 의무),(제15조 재판관할 법적분쟁)을 기본으로 하여 회원 여러분이 신뢰를 바탕으로 보다 안전하고 편안하게 '스쿨라이프'를 이용하게 하는데 그 목적이 있습니다.</li>
                </ul>
              </li>
              <li>회원정보의 수집방법, 종류 및 이용범위
                <ul>
                  <li>'스쿨라이프' 홈페이지를 통해 수집된 회원님이 제공하신 개인정보는 오직 회원님에게 최적화된 서비스를 제공하기 위해서만 수집 이용되고 있습니다.<br />
                    우선, '스쿨라이프'의 이용을 위해서는 기본적으로 회원님(귀교)의 담당자 실명, 주소 및 우편번호, 연락 전화번호, E-mail 주소, 학교계정(ID), 사용자계정(ID) / 사용자암호 등의 기본정보가 필요합니다.</li>
                  <li>‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’에 의거하여 고유식별번호(주민등록번호, 운전면허번호, 여권번호, 외국인등록증번호)는 수집하지 않습니다.</li>
                  <li>더 나아가 새롭고 발전된 특정서비스의 제공을 위해 회원님의 자발적인 참여와 동의를 조건으로 개별 및 집단적 설문조사 등을 통해 추가적인 정보를 수집하거나, 변경된 서비스 내용을 E-mail로 알려드릴 수 있습니다.</li>
                  <li>상기의 방법을 통해 수집된 개인정보는 원칙적으로 해당서비스나 기타 조사 당시 고지 또는 명시된 목적 이외의 용도로는 사용되지 않습니다. 단, 법률 제17조에 의거 회원님이 동의하거나 다음의 경우에는 예외로 합니다.
                    <ol>
                      <li>법률 또는 다른 법령에 특별한 규정이 있는 경우.</li>
                      <li>서비스의 제공에 따른 요금정산을 위하여 필요한 경우.</li>
                      <li>통계작성ㆍ학술연구 또는 시장조사를 위하여 필요한 경우로서 특정개인을 식별할 수 없는 형태로 제공하는 경우</li>
                    </ol>
                  </li>
                </ul>
              </li>
              <li>개인정보의 보유 기간
                <ul>
                  <li>회원님의 개인정보는 '스쿨라이프'의 회원으로서 서비스를 이용하는 동안 '스쿨라이프'가 관리하고 '스쿨라이프'에 의해 보호되며, 앞서 언급된 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에 당해 정보는 지체 없이 파기됩니다. 단, 회원님의 동의나 상법 등 관련법률에 특별한 규정이 있는 경우에 한해 예외로 합니다.</li>
                </ul>
              </li>
              <li>개인정보 파기 절차 및 방법
                <ul>
                  <li>회원님의 개인정보는 원칙적으로개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다.<br />
                    회사의 개인정보 파기절차 및 방법은 다음과 같습니다.
                    <ol>
                      <li>파기절차: 이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조)일정 기간 저장된 후 파기됩니다.<br />
                        동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다.</li>
                      <li>파기방법: 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.<br />
                        전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
                    </ol>
                  </li>
                </ul>
              </li>
              <li>개인정보의 공유
                <ul>
                  <li>'스쿨라이프' 이용약관을 위배한 회원이나, '스쿨라이프' 서비스를 이용하여 타인에게 법적인 피해를 입히거나 미풍양속을 해치는 행위를 한 회원 등에게 법적인 조취를 취할 목적으로 개인정보를 공개해야 한다고 판단되는 충분한 근거가 있는 경우는 예외로 합니다.</li>
                  <li>또한 '스쿨라이프'는 보다 나은 서비스 제공을 목적으로 회원님의 개인정보를 비지니스 파트너(협력회사)와 공유할 수 있습니다. 이러한 경우에는 정보를 수집하고 제공하기 이전에 회원님께 동의를 구할 것입니다.</li>
                </ul>
              </li>
              <li>쿠키의 운용 및 활용
                <ul>
                  <li>'스쿨라이프'사용자에게 최적화된 양질의 서비스를 제공하기 위한 일환으로 '스쿨라이프'는 회원님에 대한 정보를 저장하기 위하여 '쿠키'라는 것을 사용합니다. '쿠키'는 HTTP 서버(어떤 웹사이트를 호스트하는 서버)가 사용자 브라우저에게 보내는 조그마한 데이터 꾸러미로서 귀하의 컴퓨터 하드 드라이버에 저장됩니다. 회원님께서 '스쿨라이프' 서비스를 이용하기 위해서는 쿠키를 허용하여야 합니다.</li>
                  <li>'스쿨라이프'는 유용한 서비스를 전달하기 위해 쿠키를 사용하여 '스쿨라이프' 서비스 장비에 저장된 정보를 통해 회원님이 누구인지 알아내고 서비스에 필요한 회원님의 계정(이용자ID), '스쿨라이프' 할당량등에 관한 정보를 찾아냅니다.</li>
                  <li>물론 쿠키에 대한 선택권은 회원님께서 가지고 있습니다. 회원님의 브라우저에서 옵션을 선택함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 쿠키의 저장을 거부할 수 있습니다. 단, 쿠키의 저장을 거부하실 경우 '스쿨라이프' 서비스 이용하시는데에 불편은 있을수 있습니다.</li>
                </ul>
              </li>
              <li>개인정보 유출방지를 위한 기술적, 관리적 보호 조치
                <ul>
                  <li>'스쿨라이프'는 회원님의 개인정보보호를 위하여 개인정보 관리자의 수를 최소한으로 한정하여 특별관리하고 있으며, 해당 관리자에 대하여 유출방지에 대한 의식고취 및 대책개발을 위한 지속적인 교육을 실시합니다.<br />
                    또한 기술적으로도 '스쿨라이프'는 외부로부터의 해킹이나 도난 분실의 방지를 위해 기본적인 방화벽을 설치 운영하고 있습니다.</li>
                  <li>회원님의 개인정보는 비밀번호에 의하여 보호되고 있으므로, 회원님 아이디에 대한 관리는 본인에 의해서만 가능합니다.
                    따라서 다른 사람과 컴퓨터를 공유하여 사용하거나 공공장소에서 서비스를 이용하는 경우 반드시 로그아웃(Log-out)을 정상적으로 하시고 브라우저를 종료하셔서, 공공장소에서의 개인정보 유출 방지에 주의하셔야 합니다.</li>
                </ul>
              </li>
              <li>개인정보의 열람, 정정, 삭제 및 동의 철회의 방법
                <ul>
                  <li>회원님은 언제나 본인의 개인정보의 열람 및 오류정정을 요구할 수 있고, 이용이나 제3자에게의 제공에 대한 동의 또한 언제나 철회할 수 있으며, '스쿨라이프'는 이에 대해 지체 없이 필요한 조치를 취합니다.<br />
                    또한 '스쿨라이프'는 오류정정 요구가 있을 시 그 정정 때까지 당해 해당정보를 이용하지 않습니다.</li>
                  <li>열람, 오류정정 또는 동의철회의 방법으로 인터넷 홈페이지를 이용하는 경우 '스쿨라이프' 홈페이지(URL : http://www.school-life.co.kr/)에 학교 아이디, 회원 아이디와 암호를 입력하고 로그인하신 후, [기본환경설정] 메뉴에서 일반정보 변경이 가능합니다.또한, 전화로 신청하는 경우 '스쿨라이프' 고객센터(070-8853-8886)로 열람/변경 신청을 하실 수 있습니다.</li>
                  <li>회원 탈퇴(가입해지)를 원하시면 회원님(귀교)의 담당자 성함, 학교아이디, 담당자 아이디, E-mail 주소, 연락처와 같은 정보를 기재하셔서 '스쿨라이프'로 메일을 보내시면 확인후 탈퇴 처리됩니다.<br />
                    단, 메일을 보내실 때에는 반드시 회원가입시 신청한 E-mail 주소를 이용하여 메일을 보내셔야 합니다.</li>
                  <li>위와 관련하여 불만이나 의견이 있으신 회원께서는 아래에 명기된 개인정보 관리자에게 메일 또는 전화로 의견을 주시면 접수 즉시 조치하고 그 결과를 알려드리겠습니다.</li>
                </ul>
              </li>
              <li>개인정보 관련 분쟁조정
                <ul>
                  <li>회원여러분이 개인정보 관리에 대한 불만사항이나 분쟁이 있을 경우 개인정보 관리담당자에게 중재를 요청하실 수 있습니다.</li>
                  <li>'스쿨라이프'가 직접 관련된 개인정보침해를 이유로 회원님이 피해구제를 받고자 하는 경우에는 한국정보보호센터 내의 개인정보 침해보호센터에 설치된 개인정보분쟁 조정위원회에 중재 및 조정을 신청할 수 있습니다.<br />
                    - 개인정보침해신고센터 전화번호<br />
                    서울지역 : 지역번호와 국번 없이 1336<br />
                    서울 외 지역 : (02)-1336<br />
                    - 개인정보침해신고센터 인터넷 주소(URL : http://www.cyberprivacy.or.kr)</li>
                </ul>
              </li>
              <li>개인정보 보호 정책의 개정
                <ul>
                  <li>'스쿨라이프'는 법률 및 관계법령의 개정 또는 보다 나은 서비스의 제공을 위해 본 개인정보처리방침을 변경할 수 있으며, 변경 시에는 공지를 통하여 알려드립니다.</li>
                </ul>
              </li>
              <li>개인정보 보호를 위하여 회원님께서 유의하셔야 할 사항
                <ul>
                  <li>회원님의 사용자ID나 비밀번호와 '스쿨라이프'서비스내에서 학생정보(학번, 이름, 학부모 핸드폰번호)를 [파일로 내보내기] 했을시 발생되는 파일 등의 정보는 회원님(귀교) 담당자 본인이 철저히 관리하여야 하며,회원님(귀교)의 부주의로 인한 사고는 회원 본인이 책임지게 됩니다.</li>
                  <li>또한 '스쿨라이프' 서비스 내에서 당사가 주관하지 않는 이벤트 참여, 동호회 및 기타 회원제 서비스 가입 시에 별도로 요구되는 개인정보는 '스쿨라이프'와는 독립된 별도의 운영자가 독자적으로 이용하고 그 관리책임을 지므로 이에 대한 동의 시 신중하게 판단하시기 바랍니다.</li>
                </ul>
              </li>
            </ul>
            <div id="subRight_7_2">개인정보 보호책임자 및 보호담당자 <br />
              - 성 명 : 정진수<br />
              - 소 속 : (주)아이디프로<br />
              - 전 화 : 070-8853-8886 <br />
              - E-mail address : <a href="mailto:help@idpro.kr">help@idpro.kr</a><br />
              <br />
              본 개인정보보호정책은 2006. 01. 02. 부터 시행합니다.<br />
              본 개인정보보호정책은 2012. 08. 16. 부터 시행하고, 2006.01.02. 부터 시행되던 종전의 개인정보보호정책은 본 개인정보보호정책으로 대체합니다.<br />
              본 개인정보보호정책은 2016. 08. 22. 부터 시행하고, 2012.08.16. 부터 시행되던 종전의 개인정보보호정책은 본 개인정보보호정책으로 대체합니다.<br />
              본 개인정보보호정책은 2024. 01. 23. 부터 시행하고, 2016.08.22. 부터 시행되던 종전의 개인정보보호정책은 본 개인정보보호정책으로 대체합니다.<br />
            </div>
          </div>
        </Container>
      </>
    );
  }

}

export default TermsCmp;